<div
  class="card trnasiction-card"
  *ngIf="invite.sender && invite.recipient && invite.target"
>
  <div
    class="card-header bg-c-green"
    [ngClass]="{
      'bg-c-blue': invite.status === 'requested',
      'bg-c-green': invite.status === 'accepted',
      'bg-c-pink': invite.status === 'rejected'
    }"
  >
    <h5 class="text-white">
      <span>Status: {{ invite.status }}</span>
      <span class="d-block">
        Invite received,
        {{ invite.createdAt | date: "longDate":"UTC" }}
      </span>
    </h5>
    <div class="card-header-right">
      <div class="transection-preogress complited">
        <span
          class="fa fa-microphone f-20"
          *ngIf="invite.targetModel === 'Discussion'"
        >
        </span>
        <span
          class="fa fa-users f-20"
          *ngIf="invite.targetModel === 'Community'"
        >
        </span>
      </div>
    </div>
  </div>

  <div class="card-block text-center">
    <!-- Invite user details -->
    <div>
      <div
        class="invite-user col"
        *ngIf="invite.sender.username === currentUser.username"
      >
        <div class="text-center">
          <!-- Invite user image start -->
          <a
            class="media-middle"
            [routerLink]="['/profile', invite.recipient.username]"
          >
            <img
              *ngIf="invite.recipient.image"
              class="invite-user-img"
              [src]="invite.recipient.image"
              alt="recipient-image"
            />
            <img
              *ngIf="!invite.recipient.image"
              class="invite-user-img"
              [src]="defaultUserImg"
              alt="recipient-image"
            />
          </a>
        </div>

        <!-- Invite user name start -->
        <div class="text-center">
          <span class="d-block">Recipient</span>
          <a [routerLink]="['/profile', invite.recipient.username]">
            <p class="text-muted">
              {{ invite.recipient.username | slice: 0:25 }}
            </p>
          </a>
        </div>
      </div>

      <div
        class="invite-user col"
        *ngIf="invite.recipient.username === currentUser.username"
      >
        <div class="text-center">
          <!-- Invite user image start -->
          <a
            class="media-middle"
            [routerLink]="['/profile', invite.sender.username]"
          >
            <img
              *ngIf="invite.sender.image"
              class="invite-user-img"
              [src]="invite.sender.image"
              alt="sender-image"
            />
            <img
              *ngIf="!invite.sender.image"
              class="invite-user-img"
              [src]="defaultUserImg"
              alt="sender-image"
            />
          </a>
        </div>

        <!-- Invite user name start -->
        <div class="text-center">
          <span class="d-block">Sender</span>
          <a [routerLink]="['/profile', invite.sender.username]">
            <p class="text-muted">
              {{ invite.sender.username | slice: 0:25 }}
            </p>
          </a>
        </div>
      </div>
    </div>
    <!-- Invite user details -->

    <hr />

    <!-- Invite details -->
    <div>
      <div>
        <h6>
          <span class="d-block" *ngIf="invite.targetModel === 'Discussion'">
            nDaba details:
          </span>
          <span class="d-block" *ngIf="invite.targetModel === 'Community'">
            uMuzi details:
          </span>
        </h6>
      </div>

      <a
        *ngIf="invite.targetModel === 'Discussion'"
        [routerLink]="['/discussion', invite.target.slug]"
      >
        <p [innerHTML]="invite.target.title | slice: 0:75" class="text-muted">
          ...
        </p>
      </a>
      <a
        *ngIf="invite.targetModel === 'Community'"
        [routerLink]="['/community', invite.target.name]"
      >
        <p
          [innerHTML]="invite.target.name | slice: 0:75"
          class="text-muted"
        ></p>
      </a>
    </div>
    <!-- Invite details -->
  </div>
  <div
    class="b-t-default transection-footer row"
    *ngIf="
      invite.status !== 'accepted' &&
      invite.recipient.username === currentUser.username
    "
  >
    <div class="col-6 b-r-default">
      <a
        [ngClass]="{ disabled: loading }"
        (click)="openInviteAcceptConfirmation(invite)"
      >
        <i class="fa fa-check-circle m-r-10 text-success"></i>
        Accept
      </a>
    </div>
    <div class="col-6">
      <a
        [ngClass]="{ disabled: loading }"
        (click)="openInviteRejectConfirmation(invite)"
      >
        <i class="fa fa-times-circle m-r-10 text-danger"></i>
        Reject
      </a>
    </div>
  </div>
</div>
